import Nft from "../../models/nft";
import NFTS from "../../data/dummy_data";
import {
  SET_NFTS,
  ADD_NFTS,
  UPDATE_NFT_ANIMATION,
  ADD_PUBLICKEY,
  SET_PUBLICKEY,
} from "../actions/userNft";

const initialState = {
  myNfts: [],
  publicKeys: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_NFTS:
      return {
        ...state,
        myNfts: action.newNfts,
      };
    case ADD_NFTS:
      return {
        ...state,
        myNfts: state.myNfts.concat(action.newNfts),
      };
    case UPDATE_NFT_ANIMATION:
      const index = state.myNfts.findIndex((nft) => nft.id === action.id);
      const updateNft = new Nft(
        state.myNfts[index].id,
        state.myNfts[index].title,
        state.myNfts[index].imageUrl,
        state.myNfts[index].artist,
        state.myNfts[index].collection,
        state.myNfts[index].blockchain,
        state.myNfts[index].contractAddr,
        state.myNfts[index].tokenId,
        state.myNfts[index].collectionImageUrl,
        state.myNfts[index].imageOriginalUrl,
        state.myNfts[index].imageThumbnailUrl,
        action.updatedAnimationUrl
      );

      const updatedNfts = [...state.myNfts];
      updatedNfts[index] = updateNft;

      return {
        ...state,
        myNfts: updatedNfts,
      };

    case ADD_PUBLICKEY:
      return {
        ...state,
        publicKeys: state.publicKeys.concat(action.newPublicKey),
      };
    case SET_PUBLICKEY:
      return {
        ...state,
        publicKeys: action.publicKeys,
      };
  }
  return state;
};
